import { render, staticRenderFns } from "./SearchHeader.vue?vue&type=template&id=0bfe126e&scoped=true"
import script from "./SearchHeader.vue?vue&type=script&lang=ts"
export * from "./SearchHeader.vue?vue&type=script&lang=ts"
import style0 from "./SearchHeader.vue?vue&type=style&index=0&id=0bfe126e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfe126e",
  null
  
)

export default component.exports